import{b as o}from"./ninox-components-B32GFTMO.js";var r=Object.values(o),d={width:"width",radius:"radius",color:void 0,borders:void 0};export{r as a,d as b};
//# sourceMappingURL=ninox-components-UONQ2LPV.js.map